import { useOutletContext } from "react-router-dom";
import useSWR from "swr";

export default function useTreatment(treatmentId = null) {
  const { api } = useOutletContext();

  const key = !!treatmentId ? `/treatments/${treatmentId}` : null;
  return useSWR(key, () => api.getTreatment(treatmentId));
}
